import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";

const ControlledRadioGroupSeparatedLabel = ({
	control,
	name,
	label,
	options,
	labelProps,
	className,
	labelXs = 5,
	fieldXs = 7,
	disabled,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field }) => (
				<Grid container columnSpacing={2} rowSpacing={0}>
					<Grid sx={{ display: "flex", alignItems: "start" }} size={labelXs}>
						<Typography
							variant="label"
							component="label"
							htmlFor={name}
							sx={{ ...labelProps }}
						>
							{label}:
						</Typography>
					</Grid>
					<Grid size={fieldXs}>
						<RadioGroup
							className={className}
							row
							aria-labelledby={name}
							{...field}
							{...rest}
							value={field.value || "notExisting"}
							sx={{ justifyContent: "center" }}
							disabled={disabled}
						>
							{options.map((option) => (
								<FormControlLabel
									disabled={disabled}
									key={option.value}
									value={option.value}
									control={<Radio />}
									label={option.label}
								/>
							))}
						</RadioGroup>
					</Grid>
				</Grid>
			)}
		/>
	);
};

export default ControlledRadioGroupSeparatedLabel;
